<div class="my-2" [formGroup]="addressForm">
    <div class="mb-1 row">
        <div class="col-12 col-md-4 col-xl-4">
            <app-label controlName="countryId" class="col-form-label">
                {{ 'address.country_list' | translate }}
            </app-label>
        </div>
        <div class="col-12 col-md-8 col-xl-8">
            <select class="form-control form-select" (change)="onCountrySelected()" id="countryId" formControlName="countryId">
                <option value="0">
                    {{ 'common.please_select' | translate }}
                </option>
                <option *ngFor="let country of countryList" [ngValue]="country.value">
                    {{ country.text | translate }}
                </option>
            </select>
            <app-field-error-message controlName="countryId"></app-field-error-message>
        </div>
    </div>
    <div *ngIf="!showStateSelect" class="mb-1 row">
        <div class="col-12 col-md-4 col-xl-4">
            <app-label controlName="state" class="col-form-label">
                {{ 'address.state' | translate }}
            </app-label>
        </div>
        <div class="col-12 col-md-8 col-xl-8">
            <input type="text" id="state" formControlName="state" class="form-control" />
            <app-field-error-message controlName="state"></app-field-error-message>
        </div>
    </div>
    <div *ngIf="showStateSelect" class="mb-1 row">
        <div class="col-12 col-md-4 col-xl-4">
            <app-label controlName="state" class="col-form-label">
                {{ 'address.state' | translate }}
            </app-label>
        </div>
        <div class="col-12 col-md-8 col-xl-8">
            <select class="form-control form-select" id="state" formControlName="state">
                <option value="0">
                    {{ 'common.please_select' | translate }}
                </option>
                <option *ngFor="let stateItem of stateList" [ngValue]="stateItem.value">
                    {{ stateItem.text | translate }}
                </option>
            </select>
            <app-field-error-message controlName="state"></app-field-error-message>
        </div>
    </div>

    <div class="mb-1 row">
        <div class="col-12 col-md-4 col-xl-4">
            <app-label controlName="postalCode" class="col-form-label">
                {{ 'address.postal_code' | translate }}
            </app-label>
        </div>
        <div class="col-12 col-md-8 col-xl-8">
            <input type="text" id="postalCode" formControlName="postalCode" class="form-control" />
            <app-field-error-message controlName="postalCode"></app-field-error-message>
        </div>
    </div>
    <div class="mb-1 row">
        <div class="col-12 col-md-4 col-xl-4">
            <app-label controlName="cityName" class="col-form-label">
                {{ 'address.city_name' | translate }}
            </app-label>
        </div>
        <div class="col-12 col-md-8 col-xl-8">
            <input type="text" id="cityName" formControlName="cityName" class="form-control" />
            <app-field-error-message controlName="cityName"></app-field-error-message>
        </div>
    </div>
    <div class="mb-1 row">
        <div class="col-12 col-md-4 col-xl-4">
            <app-label controlName="address1" class="col-form-label">
                {{ 'address.address_1' | translate }}
            </app-label>
        </div>
        <div class="col-12 col-md-8 col-xl-8">
            <input type="text" id="address1" formControlName="address1" class="form-control" />
            <app-field-error-message controlName="address1"></app-field-error-message>
        </div>
    </div>
    <div class="mb-1 row">
        <div class="col-12 col-md-4 col-xl-4">
            <app-label controlName="address2" class="col-form-label">
                {{ 'address.address_2' | translate }}
            </app-label>
        </div>
        <div class="col-12 col-md-8 col-xl-8">
            <input type="text" id="address2" formControlName="address2" class="form-control" />
            <app-field-error-message controlName="address2"></app-field-error-message>
        </div>
    </div>
    <div class="mb-1 row">
        <div class="col-12 col-md-4 col-xl-4">
            <app-label controlName="address3" class="col-form-label">
                {{ 'address.address_3' | translate }}
            </app-label>
        </div>
        <div class="col-12 col-md-8 col-xl-8">
            <input type="text" id="address3" formControlName="address3" class="form-control" />
            <app-field-error-message controlName="address3"></app-field-error-message>
        </div>
    </div>
</div>
